// extracted by mini-css-extract-plugin
export default {"container":"McpDetails-module__container--nvOyd","content":"McpDetails-module__content--KZRzi","hideOnDesktop":"McpDetails-module__hideOnDesktop--KJ7jm"};